import React from "react"
import { Grid } from "@material-ui/core"

import Breadcrumb from "@/components/BreadcrumbNew"
import { lovableAppUrl } from "@/config/url"
import useStyles from "@/pages/Admin/Widgets/styles"

const Widgets = () => {
	const classes = useStyles()

	return (
		<Grid
			container
			direction="column"
			className={classes.widgetsContainer}
		>
			<Grid item>
				<Breadcrumb
					data={[
						{ name: "Widgets", pathname: "/admin/attendance/widgets" }
					]}
				/>
			</Grid>
			<Grid item xs>
				<iframe
					src={lovableAppUrl.widgetsListURL}
					title="Widgets"
					className={classes.widgetsIframe}
				/>
			</Grid>
		</Grid>
	)
}

export default Widgets
